import { useState, useRef, useEffect } from 'react';

// Generic single-select pill dropdown — brand purple styling, no
// Overview-specific logic, so Platforms/Products/Forecast can reuse it.
export default function Dropdown({ value, options, onChange, placeholder = 'Select' }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function onClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener('mousedown', onClickOutside);
        return () => document.removeEventListener('mousedown', onClickOutside);
    }, []);

    const current = options.find(o => o.value === value);

    return (
        <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                style={{
                    display: 'flex', alignItems: 'center', gap: 6, padding: '7px 14px',
                    borderRadius: 999, border: '1px solid #E4DCF0', background: '#fff',
                    fontSize: 13, fontWeight: 600, color: '#3D3452', cursor: 'pointer',
                }}
            >
                {current ? current.label : placeholder}
                <span style={{ fontSize: 10, color: '#8C82A0', transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 0.15s' }}>▾</span>
            </button>
            {open && (
                <div style={{
                    position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 20, minWidth: 180,
                    background: '#fff', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', border: '1px solid #EFEAF6',
                    padding: 6,
                }}>
                    {options.map(o => (
                        <div
                            key={o.value}
                            onClick={() => { onChange(o.value); setOpen(false); }}
                            style={{
                                padding: '8px 10px', borderRadius: 6, fontSize: 13, cursor: 'pointer',
                                fontWeight: o.value === value ? 700 : 500,
                                color: o.value === value ? '#6E58A6' : '#3D3452',
                                background: o.value === value ? '#F1EDF9' : 'transparent',
                            }}
                        >
                            {o.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
